import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function BookSection() {
  return <section id="book" className="py-24 bg-rhino-charcoal relative" data-id="element-33">
      <div className="container mx-auto px-6" data-id="element-34">
        <div className="max-w-3xl mx-auto text-center" data-id="element-35">
          <FadeIn data-id="element-36">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white tracking-wide mb-10" data-id="element-37">
              WHAT IS THE BOOK <br className="hidden sm:block" data-id="element-38" />
              <span className="text-rhino-gold" data-id="element-39">"THE RHINO MIND"?</span>
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-40">
            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed text-left" data-id="element-41">
              Prepare to transform your mindset. The Rhino Mind book is the
              ultimate guide to breaking through barriers, building unshakeable
              discipline, and charging toward your God-given potential. It's not
              just theory; it's a battle-tested strategy for life.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-42">
            <div className="bg-rhino-black/60 p-8 md:p-12 rounded-sm border-l-4 border-rhino-gold shadow-2xl mb-12" data-id="element-43">
              <p className="text-lg md:text-xl text-gray-300 leading-relaxed text-left italic" data-id="element-44">
                "The Rhino Mind is more than a self-help book. It is a
                faith-driven mindset that refuses to live small, refuses to
                stall in life. It is a strategic playbook for anyone tired of
                settling for less than their God-given potential. It is for
                those ready to charge forward with strength, discipline, and
                decisiveness. Learn how to cultivate the mindset required for
                growth and the relentless charge required for victory."
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-45">
            <button disabled className="px-8 py-4 bg-rhino-grey text-gray-500 font-heading font-bold text-lg tracking-wider uppercase rounded cursor-not-allowed border border-rhino-grey" data-id="element-46">
              Coming Soon
            </button>
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 bg-rhino-gold text-rhino-black font-heading font-bold text-lg tracking-wider uppercase rounded shadow-[0_0_15px_rgba(212,160,23,0.2)] hover:bg-rhino-gold-hover transition-all" data-id="element-47">
              Get Notified
            </motion.button>
          </FadeIn>
        </div>
      </div>
    </section>;
}